import React from 'react';
import {connect} from 'react-redux';
import {loginByToken, logOutPassenger} from '../../actions/authenticationActions';
import { navigate } from '../../utils/navigationUtils';

class PassengerTokenLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loginInProgress: false,
            errors: {},
            loginFailed: false,
        };
    }

    componentDidMount() {
        this.login();
    }

    render() {
        if(this.state.loginFailed) {
            return (<div className="container mx-auto">Login failed. Please make sure the token is valid</div>);
        }

        if(this.state.loginInProgress) {
            return (<div className="container mx-auto">Login in progress. Please wait</div>);
        }


        return (
            <div className="container mx-auto">
                Login starting.
            </div>
        );
    }

    async login() {
        this.setState({loginInProgress: true});
        await logOutPassenger();
        const valid = await this.props.loginByToken(this.props.match.params.token);
        if (valid) {
            navigate('/itinerary');
        }
        else {
            this.setState({
                loginInProgress: false,
                loginFailed: true,
            });
        }
    }
}


export default connect(null, {loginByToken}) (PassengerTokenLogin);